import React, { useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import logo from "../assets/logo.png";
import Insta from "../assets/svgs/instagram.svg";
import Tiktok from "../assets/svgs/tiktok.svg";
import Youtube from "../assets/svgs/youtube.svg";
import howToPlay from "../assets/howToPlay.png";

const Info = ({ handleShow }) => {
  const [values] = useState(["a", "", "", ""]);

  return (
    <div className="bg-[#0000001a] fixed z-50 top-0 bottom-0 left-0 right-0">
      <div className="mx-auto max-w-[630px] w-full bg-white h-full">
        <nav class="navbar">
          <div class="nav-left">
            <BiArrowBack
              size={24}
              onClick={handleShow}
              className="cursor-pointer"
            />
          </div>
          <div class="nav-right">
            <img
              src={logo}
              alt="Sporting Cryptic"
              className="size-10 bg-white rounded-full"
            />
          </div>
        </nav>
        <div className="overflow-y-scroll h-[calc(100%_-_60px)]">
          <div className="bg-primary2 py-3 px-6 flex flex-col gap-2">
            <p className="font-bold text-xl">This game started as a TikTok channel!</p>
            <p>
              Watching our clue explanations is a great way to learn how to play and develop your
              intuition. Just ask our tens of thousands of followers! We post explanations of every
              Sporting Cryptic clue.
            </p>
            <div className="flex gap-3 items-center">
              <a href="#">
                <img
                  src={Insta}
                  alt="instagram"
                  className="size-10"
                />
              </a>
              <a href="#">
                <img
                  src={Tiktok}
                  alt="Tiktok"
                  className="size-10"
                />
              </a>
              <a href="#">
                <img
                  src={Youtube}
                  alt="Youtube"
                  className="size-10"
                />
              </a>
            </div>
          </div>
          <div className="py-3 px-6">
            <h3 className="text-3xl font-bold pb-2">How To Play</h3>
            <p className="pb-2">Solve the cryptic clue by typing your answer in the grid!</p>
            <div className="flex justify-center pb-4 md:px-10">
              <img
                src={howToPlay}
                alt="how to play"
              />
            </div>
            <div className="flex flex-col gap-2">
              <ul className="styled-list">
                <li>
                  When you need some help, ask for a hint or choose to see a random letter in the
                  grid.
                </li>
                <li>
                  As you're helped, your <span className="font-semibold">shown count </span>{" "}
                  increases. This is your way of measuring how you did and comparing with friends.
                </li>
                <li>
                  The <span className="font-semibold">par number</span> indicates the typical amount
                  of help a player might need on this clue. If you go under - well done! If over,
                  maybe this just wasn't your clue.
                </li>
                <li>
                  When you fill the grid, the <span className="font-semibold">show letter</span>{" "}
                  button changes to <span className="font-semibold">check answer</span>, and you can
                  see if you got it right!
                </li>
              </ul>
            </div>
          </div>
          <div className="bg-primary2 py-3 px-6">
            <h3 className="font-bold text-2xl mb-2">Have Fun!</h3>
            <p className="py-2">This game isn't about getting it right all the time.</p>
            <p className="font-bold py-2">
              Sometimes the best clues are the ones that blow your mind, totally baffle you, and
              where you pick up new tricks for next time!
            </p>
            <p className="pt-4">
              P.S. We use the helping letters and hints all the time - they're your friends 😄
            </p>
          </div>
          <div className="py-3 px-6">
            <h3 className="font-bold text-3xl mb-4 ">How To Solve</h3>
            <div className="flex flex-col gap-4">
              <p>
                Each cryptic clue has a{" "}
                <span className="font-semibold bg-primary2">definition</span> and a secret meaning
                hidden in wordplay, which is made up of{" "}
                <span className="underline decoration-4 font-semibold decoration-pink-300">
                  signpost(s)
                </span>{" "}
                and <span className="bg-[rgb(245,209,253)]">fodder</span>.
              </p>
              <p>
                The first step to solving a cryptic clue can be identifying which part is fodder,
                signpost or definition:
              </p>
              <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                <li>
                  <span className="bg-[rgb(245,209,253)]">Fodder:</span> a strange combination of
                  words and letters is often a sign of wordplay fodder - you need to use these
                  letters.
                </li>
                <li>
                  <span className="underline decoration-4 font-semibold decoration-pink-300">
                    Signposts:
                  </span>{" "}
                  words that tell you what to do with the fodder.
                </li>
                <li>
                  <span className="bg-primary2">Definiton:</span> one or more words that have a
                  direct synonym which is the answer. The definition always appears at the beginning
                  or end of the clue.
                </li>
              </ul>
              <h3 className="font-semibold text-2xl">Example:</h3>
              <div>
                <span className="bg-primary2"> Struggle</span>{" "}
                <span className="bg-[rgb(245,209,253)]">with siesta</span>{" "}
                <span className="underline decoration-4  decoration-pink-300">upsetting </span>
                <span className="bg-primary2">the</span>{" "}
                <span className="bg-[rgb(245,209,253)]">with siesta</span>{" "}
                <span className="underline decoration-4  decoration-pink-300"> Spanish </span>
              </div>
              <div className="flex items-center gap-2 mx-auto h-full">
                {values.map((value, index) => (
                  <input
                    key={index}
                    type="text"
                    value={value}
                    maxLength="1"
                    className={`size-11 text-2xl text-white lowercase cursor-pointer text-center p-1 font-semibold rounded-md bg-primary shadow-[-4px_4px_0px_0px_black]`}
                    readOnly
                  />
                ))}
              </div>
              <div className="py-6">
                <p className="font-semibold"> The definition is Struggle.</p>
                <p>
                  It could also be "the Spanish" (which comes at the end) but it's hard to think of
                  7-letter synonyms for "the Spanish". And you might already be able to think of a
                  synonym for struggle that fits here!
                </p>
                <p className="font-semibold py-4">
                  The wordplay is{" "}
                  <span className="underline">with siesta upsetting the Spanish</span>. How does
                  this work?
                </p>
                <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                  <li>
                    <span className="bg-[rgb(245,209,253)]">with:</span> s fodder and needs us to
                    find a legitimate abbreviation, which in this case is just “w”.
                  </li>
                  <li>
                    <span className="underline decoration-4 font-semibold decoration-pink-300">
                      siesta:
                    </span>{" "}
                    is fodder and needs us to find a synonym - “rest”
                  </li>
                  <li>
                    <span className="bg-primary2">upsetting:</span> is a signpost, telling us to
                    upset or rearrange a word
                  </li>
                  <li>
                    <span className="bg-primary2">spanish:</span> is also a signpost, telling us we
                    need to find the Spanish equivalent for a word.
                  </li>
                  <li>
                    <span className="bg-[rgb(245,209,253)]">the:</span> is the fodder for both
                    "Spanish" and "upsetting". We need to find a Spanish word for "the" - "el" - and
                    rearrange it. This gives us "le".
                  </li>
                </ul>
                <p className="bg-primary2 p-2 mt-4 rounded">
                  All this gives us w + rest + le, or "wrestle" - another word for struggle.
                </p>
                <div className="flex items-center gap-2 mx-auto h-full justify-center mt-4">
                  {values.map((value, index) => (
                    <input
                      key={index}
                      type="text"
                      value={value}
                      maxLength="1"
                      className={`size-11 text-2xl text-white lowercase cursor-pointer text-center p-1 font-semibold rounded-md bg-primary shadow-[-4px_4px_0px_0px_black]`}
                      readOnly
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="bg-primary2 py-3 px-6">
            <h3 className="font-bold text-2xl mb-4">Learn as you Play!</h3>
            <p className="font-semibold">
              You don't need to understand every part of the clue to solve it.
            </p>
            <ol className="py-2 list-decimal pl-4 flex flex-col gap-1">
              <li>
                Sometimes you might{" "}
                <span className="font-semibold">identify and solve the definition</span> without
                understanding the wordplay.
              </li>
              <li>
                Or perhaps sometimes you{" "}
                <span className="font-semibold">figure out the wordplay</span> without even knowing
                the word in the answer (it happens!)
              </li>
              <li>
                <span className="font-semibold">
                  A lot of the time you end up moving between wordplay and definition -
                  understanding part
                </span>{" "}
                - understanding part of the wordplay, which gives you a good hint about how the
                definition works, which then helps you solve the rest of the wordplay.
              </li>
            </ol>
            <p className="font-semibold pt-6 pb-4">
              This means that you can learn as you play: simultaneously getting the answer and
              increasing your knowledge of words and cryptic clues!
            </p>
          </div>
          <div className="px-6 pt-6 pb-10">
            <h3 className="text-2xl font-black mb-2">Common Signposts</h3>
            <div className="flex flex-col gap-10">
              <div className="flex flex-col gap-2">
                <h3 className="font-semibold">Rearranging</h3>
                <p>
                  Probably the easiest and most common, this signpost tells you to rearrange a word
                  or words - to find an anagram.
                </p>
                <p>Common rearranging signposts:</p>
                <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                  <li>order</li>
                  <li>destroy</li>
                  <li>hit</li>
                  <li>mix</li>
                  <li>sort</li>
                </ul>
                <p>
                  Example: <span className="font-semibold">Guns of war or any power play (8)</span>.
                  By playing with the words "any power", we can rearrange them into the word
                  "weaponry", for guns of war.
                </p>
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="font-semibold">Shortening:</h3>
                <p>
                  A shortening signpost directs you to remove part of a word, or keep only part of a
                  word.
                </p>
                <p>Common shortening signposts:</p>
                <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                  <li>order</li>
                  <li>destroy</li>
                  <li>hit</li>
                  <li>mix</li>
                  <li>sort</li>
                </ul>
                <p>
                  Example:{" "}
                  <span className="font-semibold">Fugitive without a landing strip (6).</span>.
                  Here, "without a" instructs us to remove an "a" from runaway (for fugitive),
                  giving "runway" - a landing strip!
                </p>
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="font-semibold">Alternating:</h3>
                <p>
                  This signpost asks you to look for every second letter of a word or multiple
                  words.
                </p>
                <p>Common alternating signposts:</p>

                <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                  <li>even</li>
                  <li>odd</li>
                  <li>regular</li>
                  <li>uneven</li>
                </ul>

                <p>
                  Example:{" "}
                  <span className="font-semibold">
                    Type of lettuce cooks regularly discard (3).
                  </span>{" "}
                  By discarding regular letters from "cooks", you get "cos", a type of lettuce!
                </p>
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="font-semibold">Containing:</h3>
                <p>A containing signpost alerts you to a word contained within multiple words.</p>
                <p>Common containing signposts:</p>

                <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                  <li>within</li>
                  <li>containing</li>
                  <li>captured</li>
                  <li>among</li>
                </ul>

                <p>
                  Example:{" "}
                  <span className="font-semibold">
                    Warship poised to capture semiaquatic animal (5).
                  </span>{" "}
                  Captured within "Warship poised" is "hippo", a semiaquatic animal!
                </p>
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="font-semibold">Translating:</h3>
                <p>
                  A translating signpost alerts you to translate a word - usually a very short
                  common word - into another language.
                </p>
                <p>Common translating signposts:</p>

                <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                  <li>
                    <span className="font-semibold">the French</span> = "le"
                  </li>
                  <li>
                    <span className="font-semibold">the Spanish</span> = "el"
                  </li>
                </ul>
              </div>

              <div className="flex flex-col gap-2">
                <h3 className="font-semibold">Pronouncing:</h3>
                <p>
                  This signpost wants you to look for homophones. Say a fodder word out loud and
                  replace it with another word that sounds like it.
                </p>
                <p>Common pronouncing signposts:</p>

                <ul className="list-disc list-outside pl-6 flex flex-col gap-1">
                  <li>Say</li>
                  <li>Hear</li>
                  <li>Report</li>
                  <li>Utterly</li>
                </ul>

                <p>
                  Example: <span className="font-semibold">Owing to some moisture, say (3).</span>{" "}
                  "Dew" is some moisture, and sounds like "due", which means "owing".
                </p>
              </div>
            </div>
          </div>

          <div className="px-6 pt-6 pb-10 bg-primary2">
            <h2 className="font-bold text-2xl py-4">Synonyms & Abbreviations</h2>
            <h3 className="py-2 font-semibold">Synonyms:</h3>
            <p>
              Often, a word in a clue simply needs to be replaced with one of its synonyms. In our
              example above, the word "siesta" needed to be replaced with "rest".
            </p>
            <p className="py-6 italic">
              Note: the clue setter is trying to trick you. They might make the clue seem like it's
              about a "club" as in a nightclub, but require "putter" - a golf clue - as the synonym.
            </p>
            <h3 className="py-2 font-semibold">Abbrevations:</h3>
            <p>
              Many words have legitimate abbreviations. In our example above, "with" can be
              shortened to "w".
            </p>
            <p className="py-6 italic">
              Note: you can't simply shorten any word to its first letter - only if the dictionary
              has the abbreviation. Of course, it's impossible to know all the legitimate
              abbreviations! But, you do pick up quite a lot over time, and in combination with the
              definition and other parts of the wordplay, you can learn them as you play!
            </p>
            <p className="italic">
              The first time we saw "check" shortened to "ch" in a clue, we thought that that was a
              highly unlikely abbreviation. But, it's a chess notation, and it's in the dictionary!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
